import React, { useEffect, useRef, useState } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import SliderWrapper from './_SlickSlider'
import { isEmpty } from 'lodash'
import EditMenu from '../editMenu'
import CustomImage from '../../customImage/customImage'
import AddSection from '../addSection'
import useTemplateHook from '../templateHook'
import useAxios from 'axios-hooks'
import getSymbolFromCurrency from 'currency-symbol-map'
import LoaderTile from '../../contentCard/loaderTile'

const ProductFaceCardCarouselDynamic = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const sliderRef = useRef(null)
  const { data, id } = componentData
  const {
    LeftArrow,
    RightArrow,
    getTemplateImage,
    customNavigate,
    PRODUCT_FILTER_API_V2,
    getProductImage,
    XXL_SIZE,
    isStorePage,
  } = useTemplateHook()
  const [visibleSlides, setVisibleSlides] = useState(4)
  const [hoverState, setHoverState] = useState('')
  const [productData, setProductData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: productsList, loading: productsListLoading }, productsListCall] = useAxios(
    {
      url: `${PRODUCT_FILTER_API_V2}`,
      method: 'post',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth > XXL_SIZE && !isStorePage) {
      setVisibleSlides(5)
    } else {
      setVisibleSlides(4)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  useEffect(() => {
    if (productsList && productsList.success) {
      if (data.type === 'STATIC') {
        productsList?.data.sort((a, b) => {
          let sortingArr = data.product_data
          return sortingArr.indexOf(a._id) - sortingArr.indexOf(b._id)
        })
      }
      setProductData(productsList.data)
    }
  }, [productsList])

  useEffect(() => {
    if (data?.card_data?.length > 0 && sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0)
      }, 100)
    }
  }, [data?.card_data])

  useEffect(() => {
    if (!isEmpty(data.product_data) || !isEmpty(data.auto_payload)) {
      let filterPayload =
        data.type === 'STATIC'
          ? { product_ids: data.product_data }
          : {
              system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
              custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
            }

      productsListCall({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data.type === 'STATIC'
              ? ''
              : data?.order_by === 'title'
              ? `title.${language}`
              : data?.order_by,
          reverse: data.type === 'STATIC' ? '' : data?.reverse,
          page_size: 100,
        },
      })
    } else {
      setProductData([])
    }
  }, [data?.auto_payload, data?.product_data, data?.type, data?.order_by, data?.reverse])

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: window.innerWidth <= 768 ? '24px' : '46px',
          height: window.innerWidth <= 768 ? '24px' : '46px',
          position: 'absolute',
          top: '40%',
          right: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${RightArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={RightArrow}
          alt="Next"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'block',
          background: 'transparent',
          width: window.innerWidth <= 768 ? '24px' : '46px',
          height: window.innerWidth <= 768 ? '24px' : '46px',
          position: 'absolute',
          top: '40%',
          left: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${LeftArrow})`,
        }}
        onClick={onClick}
      >
        <img
          src={LeftArrow}
          alt="Previous"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    )
  }

  const settings = {
    dots: false,
    autoplaySpeed: 2500,
    infinite: false,
    slidesToShow: visibleSlides,
    slidesToScroll: 1,
    centerMode: false,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleRedirect = (id) => {
    customNavigate('DIRECT', `/product/${id}`, isEdit)
  }

  return (
    <div
      className={`w-full py-6 ${visibleSlides === 5 ? '' : 'px-4'}  relative  ${
        isEdit && hoverState && 'component-hover-class'
      } `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_color', 'component_color', '') }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div
        style={{
          maxWidth: visibleSlides === 5 ? '100%' : '1269px',
          margin: '0 auto',
          padding: visibleSlides === 5 ? '0 5.52%' : '0',
        }}
      >
        <p
          style={{ color: getStyleValue('component_color', 'component_heading_color', '') }}
          className="text-xs sm:text-[0.8rem] md:text-[1.5rem] font-bold mb-8"
        >
          {data?.title}
        </p>
        <SliderWrapper>
          <Slider {...settings} ref={sliderRef}>
            {!isEmpty(productData) ? (
              productData.map((item, index) => (
                <div key={index} className="relative group cursor-pointer">
                  {productsListLoading ? (
                    <LoaderTile aspectRatio={'1'} width={'95%'} />
                  ) : (
                    <div className="px-2" onClick={() => handleRedirect(item._id)}>
                      {/* Image Container */}
                      <div
                        className="relative flex items-center justify-center"
                        style={{ aspectRatio: '1/1' }}
                      >
                        <CustomImage
                          imageUrl={getTemplateImage(getProductImage(item?.img_s3_keys))}
                          imgAlt={item?.card_heading}
                          imgClass="w-full h-full object-cover"
                          imgStyle={{ borderRadius: '10px' }}
                        />
                      </div>

                      {/* Content */}
                      <div className="py-2">
                        <p
                          style={{
                            color: getStyleValue('card_style', 'card_title_heading', ''),
                          }}
                          className=" text-[10px] sm:text-sm md:text-base font-semibold line-clamp-2"
                        >
                          {item.title}
                        </p>

                        {/* Price Section */}
                        <div className="flex items-center gap-2 mt-2 flex-wrap">
                          <span
                            style={{
                              color: getStyleValue('card_style', 'card_pricing_text', '#ffffff'),
                              background: getStyleValue(
                                'card_style',
                                'card_pricing_background',
                                '#ff6600',
                              ),
                            }}
                            className=" rounded text-[10px] sm:text-xs md:text-sm px-1 py-[2px] font-semibold"
                          >
                            {item?.discount?.enabled
                              ? parseInt(
                                  item?.price -
                                    (item?.price * parseInt(item?.discount.discount_value)) / 100,
                                )
                              : parseInt(item?.price)}{' '}
                            {getSymbolFromCurrency(item.currency || 'USD')}
                          </span>

                          {item?.discount?.enabled && (
                            <>
                              <span
                                className="text-[10px] sm:text-xs md:text-sm line-through"
                                style={{
                                  color: getStyleValue('card_style', 'card_old_pricing', ''),
                                }}
                              >
                                {item.price} {getSymbolFromCurrency(item.currency || 'USD')}
                              </span>

                              <span
                                style={{
                                  color: getStyleValue('card_style', 'card_pricing_background', ''),
                                }}
                                className=" text-[10px] sm:text-xs md:text-sm font-semibold"
                              >
                                ({item?.discount.discount_value}
                                {item?.discount.value_type === 'percentage' ? '%' : ''}) OFF
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : productsListLoading ? (
              <LoaderTile aspectRatio={'1'} width={'95%'} />
            ) : (
              Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="relative group">
                  <LoaderTile aspectRatio={'1'} width={'95%'} />
                </div>
              ))
            )}
          </Slider>
        </SliderWrapper>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default ProductFaceCardCarouselDynamic
